module.exports = __webpack_public_path__ + "static/media/dadra&nagar.50aee38d.png";